import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { Auth } from 'aws-amplify';
import { createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';

const AppSyncClient = (config) => {
  const awsSyncConfig = {
    url: config.get('api.endpoints.associateNotifications'),
    region: config.get('Auth.graphQL.region'),
    auth: {
      type: config.get('Auth.graphQL.type'),
      jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken(),
    },
  };

  return new ApolloClient({
    link: ApolloLink.from([createAuthLink(awsSyncConfig), createSubscriptionHandshakeLink(awsSyncConfig)]),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
};

export default AppSyncClient;
